'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _immutable = require('immutable');

exports['default'] = function (value) {
    if (_immutable.Iterable.isIterable(value)) {
        return value.toJS();
    }

    return value;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/restful.js/dist/es5/util/serialize.js
// module id = 127
// module chunks = 3